import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { applySeo } from '@/components/seo/applySeo';
import { isNotFoundPath, normalizePathname, notFoundSeo, resolveSeo } from '@/config/seo';

export default function SeoRouteBridge() {
  const location = useLocation();

  useEffect(() => {
    const pathname = normalizePathname(location.pathname);
    if (isNotFoundPath(pathname)) {
      applySeo({ ...notFoundSeo, path: pathname, noindex: true });
      return;
    }
    const seo = resolveSeo(pathname);
    applySeo({ title: seo.title, description: seo.description, path: pathname });
  }, [location.pathname]);

  return null;
}
